import { ErrorBoundary } from "react-error-boundary";

import { ClipOfTheDay } from "../ClipOfTheDay";
import { CompetitionsBanner } from "../CompetitionsBanner";
import { ContentFeed } from "../ContentFeed";
import { SuggestedFeed } from "../SuggestedFeed";
import {
  HomepageWrapper,
  HomepageContainer,
  CappedContent,
} from "../styledComponents";
import { HomepageViewModel } from "../ViewModel";
import { ESupportedGames } from "../../../@types";
import { GAME_TO_ICON_MAP } from "../../../Components/GameSelector";
import { UserBadge } from "MVVM/Components/UserBadge";
import { AdUnit } from "../../../Components/Ads";
import { AllstarCmd, AdContainer } from "./styledComponents";

// The row-based clip feeds shown to logged-out visitors, since the
// personalized ActivityFeed (ActivityFeedHome) has nothing to show without
// an authenticated viewer.
export const LoggedOutHome = () => {
  const {
    contentFeeds,
    contentFeedsLoading,
    prosFeed,
    prosFeedLoading,
    todayInCs,
    todayInCsLoading,
  } = HomepageViewModel();
  const csIcon = GAME_TO_ICON_MAP[ESupportedGames.CS2];

  const allstarFeed = (
    <ContentFeed
      title="Clipped with !allstar"
      titleNode={
        <>
          Clipped with <AllstarCmd>!allstar</AllstarCmd>
        </>
      }
      titleTo="/!allstar"
      data={contentFeeds?.allstar?.nodes}
      loading={contentFeedsLoading}
      description="Type !allstar in match chat and we clip the round for free. Never counts against your clip limit."
      vanillaThumbnail
    />
  );

  return (
    <HomepageWrapper>
      <HomepageContainer>
        <ClipOfTheDay />
        <CappedContent>
          {allstarFeed}
          <ErrorBoundary fallback={<></>}>
            <CompetitionsBanner />
          </ErrorBoundary>
          <AdContainer>
            <AdUnit
              slotId="homepage-billboard"
              adUnitType="billboard"
              allowProgrammatic
              collapseIfEmpty
            />
          </AdContainer>

          {prosFeed || prosFeedLoading ? (
            <ContentFeed
              title="From the Pros"
              data={prosFeed}
              loading={prosFeedLoading}
              isProsFeed={true}
              icon={
                <UserBadge
                  userGroup="PRO_PLAYER"
                  style={{ marginRight: "8px" }}
                />
              }
            />
          ) : (
            <ContentFeed
              title="For You"
              data={contentFeeds?.forYou?.nodes}
              loading={contentFeedsLoading}
              vanillaThumbnail
            />
          )}

          {(todayInCsLoading || Boolean(todayInCs?.length)) && (
            <ContentFeed
              title="Today in Counter-Strike"
              data={todayInCs}
              loading={todayInCsLoading}
              isProsFeed={true}
              icon={csIcon}
            />
          )}

          <ContentFeed
            title="Counter-Strike 2"
            data={contentFeeds?.cs2?.nodes}
            loading={contentFeedsLoading}
            icon={csIcon}
          />

          <ContentFeed
            title="Recent Montages"
            data={contentFeeds?.montages?.nodes}
            loading={contentFeedsLoading}
            isMontageFeed={true}
          />

          <ErrorBoundary fallback={<></>}>
            <SuggestedFeed />
          </ErrorBoundary>
        </CappedContent>
      </HomepageContainer>
    </HomepageWrapper>
  );
};
